import React from 'react'
import { useAuth } from '../contexts/AuthContext'
import styled from 'styled-components'

const LandingContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
  text-align: center;
  padding: ${({ theme }) => theme.spacing[60]};
`

const LogoContainer = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing[80]};
`

const AlchemyLogo = styled.div`
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: ${({ theme }) => theme.border.radius.lg};
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  box-shadow: ${({ theme }) => theme.elevation.bottom.lg};
  
  &::before {
    content: "⚗️";
    font-size: 4rem;
    filter: drop-shadow(2px 2px 4px rgba(0,0,0,0.3));
  }
`

const WelcomeSection = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing[60]};
`

const WelcomeTitle = styled.h1`
  font-family: ${({ theme }) => theme.typography.heading.family};
  font-size: ${({ theme }) => theme.typography.heading.size.xl};
  font-weight: ${({ theme }) => theme.typography.weight.bold};
  color: ${({ theme }) => theme.palette.text.default};
  margin: 0 0 ${({ theme }) => theme.spacing[20]} 0;
`

const UserInfo = styled.div`
  background: ${({ theme }) => theme.palette.surface.subtle};
  padding: ${({ theme }) => theme.spacing[40]};
  border-radius: ${({ theme }) => theme.border.radius.md};
  margin-top: ${({ theme }) => theme.spacing[40]};
  display: inline-block;
`

const Username = styled.div`
  font-size: ${({ theme }) => theme.typography.body.size.lg};
  font-weight: ${({ theme }) => theme.typography.weight.medium};
  color: ${({ theme }) => theme.palette.text.default};
  margin-bottom: ${({ theme }) => theme.spacing[10]};
`

const UserRole = styled.div`
  font-size: ${({ theme }) => theme.typography.body.size.md};
  font-weight: ${({ theme }) => theme.typography.weight.regular};
  color: ${({ theme }) => theme.palette.text.support};
  text-transform: capitalize;
`

const Description = styled.p`
  font-size: ${({ theme }) => theme.typography.body.size.lg};
  color: ${({ theme }) => theme.palette.text.support};
  max-width: 600px;
  margin: ${({ theme }) => theme.spacing[40]} auto 0;
  line-height: 1.6;
`

const LandingPage: React.FC = () => {
  const { user } = useAuth()

  const formatRole = (role: string) => {
    return role.replace('_', ' ').toLowerCase()
  }

  return (
    <LandingContainer>
      <LogoContainer>
        <AlchemyLogo />
      </LogoContainer>
      
      <WelcomeSection>
        <WelcomeTitle>Welcome to Psychic Lamp</WelcomeTitle>
        
        <UserInfo>
          <Username>Welcome, {user?.username || 'User'}!</Username>
          <UserRole>Role: {user?.role ? formatRole(user.role) : 'Unknown'}</UserRole>
        </UserInfo>
        
        <Description>
          Industrial ERP System for repair and parts inventory management. 
          Navigate using the sidebar to manage devices, parts, inventory, and more.
        </Description>
      </WelcomeSection>
    </LandingContainer>
  )
}

export default LandingPage